   
    
    <label class="form-label">{{reportName|translate}}</label>

   <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
    <ng-select  [(ngModel)]="selectedReportPeriod" [placeholder]="'SelectPeriod' | translate"
                  (change)="SelectedPeriod()" [multiple]="false" [clearable]="false"
                   [hideSelected]="true">
                  <ng-option *ngFor="let period of reportPeriods" [value]="period.id">
                    {{period.name | translate}}</ng-option>
     </ng-select>
   </div>

    <div *ngIf="selectedReportPeriod=='3'" >
    <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
      <div class="form-group row">
        <div class="col-sm-12 paddingLess">
          <ngx-datepicker #fromDate class="form-control form-control-lg paddingLess" id="fromDate"
            [options]="fromDatePickeroptions" [(ngModel)]="selectedFilters.fromDate" aria-placeholder="Select">

          </ngx-datepicker>
          <i *ngIf="selectedFilters.fromDate && selectedFilters.fromDate !==null"
            class="fa fa-times c-pointer clear-datepicker-icon" (click)="clearFromDate()"></i>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
      <div class="form-group row">
        <div class="col-sm-12 paddingLess">
          <ngx-datepicker #toDate class="form-control form-control-lg paddingLess" id="toDate" [options]="toDatePickeroptions"
            [(ngModel)]="selectedFilters.toDate">

          </ngx-datepicker>
          <i *ngIf="selectedFilters.toDate && selectedFilters.toDate !==null"
            class="fa fa-times c-pointer clear-datepicker-icon" (click)="clearToDate()"></i>
        </div>
      </div>
    </div>
    </div>
<!-- <li *ngIf="isShowAuditOrdersServicesAssignment" class="nav-item"
      [ngClass]="{ 'active': auditOrdersServicesAssignment.isActive }"> -->


 <!-- Year -->
  <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12" *ngIf="selectedReportPeriod=='0'">
      <ng-select  [(ngModel)]="selectedYear"
                  [placeholder]="'SelectYear' | translate"
                  [multiple]="true" [clearable]="false"
                  [hideSelected]="true">
                  <ng-option *ngFor="let year of years" [value]="year.id">
                    {{year.name | translate}}</ng-option>
     </ng-select>
  </div>

<!-- Month -->
 <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12" *ngIf="selectedReportPeriod == '1' || selectedReportPeriod == '0'" >
    <ng-select  [(ngModel)]="selectedMonth"
                [placeholder]="'SelectMonth'|translate"
                [multiple]="true" [clearable]="true"
                [hideSelected]="true">
              <ng-option *ngFor="let month of months" [value]="month.id">
                {{month.name | translate}}</ng-option>
    </ng-select>
  </div>

  <!-- Service -->
    <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12" *ngIf="showServiceDropDown">
      <ng-select  [(ngModel)]="selectedService"
                  [placeholder]="'selectService'|translate"
                  [multiple]="true" [clearable]="false"
                  [hideSelected]="true">
                  <ng-option *ngFor="let service of Services" [value]="service.id">
                    {{service.name}}</ng-option>
     </ng-select>
  </div>

  <!-- Implantation -->
    <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12" *ngIf="showImplementationDropDown">
      <ng-select  [(ngModel)]="selectedImplantation"
                  [placeholder]="'selectImplementation'|translate"
                  [multiple]="true" [clearable]="false"
                  [hideSelected]="true">
                  <ng-option *ngFor="let implantation of Implantations" [value]="implantation.id">
                    {{implantation.name}}</ng-option>
     </ng-select>
   </div>

  <!-- Category -->
    <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12" *ngIf="showCategoryDropDown">
      <ng-select  [(ngModel)]="selectedCategory"
                  [placeholder]="'selectCategory'|translate"
                  [multiple]="true" [clearable]="false"
                  [hideSelected]="true">
                  <ng-option *ngFor="let category of Categories" [value]="category.id">
                    {{category.name}}</ng-option>
     </ng-select>
    </div>

     <!-- Customer -->
     <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12" *ngIf="showCustomerDropDown">
      <ng-select  [(ngModel)]="selectedCustomer"
                  [placeholder]="'selectCustomer' | translate"
                  [multiple]="true" [clearable]="false"
                  [hideSelected]="true">
                  <ng-option *ngFor="let customer of Customers" [value]="customer.id">
                    {{customer.name}}</ng-option>
     </ng-select>
    </div>
  
     <!-- Employee -->
     <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12" *ngIf="showEmployeeDropDown">
      <ng-select  [(ngModel)]="selectedEmployee"
                  [placeholder]="'selectEmployee' | translate"
                  [multiple]="true" [clearable]="false"
                  [hideSelected]="true">
                  <ng-option *ngFor="let employee of Employees" [value]="employee.id">
                    {{employee.name}}</ng-option>
     </ng-select>
    </div>
  
  <div class="col-sm-12 col-xs-12 col-md-12 col-lg-12">
    <button class="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn" type="submit" (click)="AddData()">
      {{'get' | translate}}
    </button>
  </div>
        
  <!-- </div> -->
   